/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { CreatePartsAgreementRestRequest } from '../../models/create-parts-agreement-rest-request';
import { PartsAgreementRestResponse } from '../../models/parts-agreement-rest-response';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface CreatePartsAgreement$Params {
  body: CreatePartsAgreementRestRequest;
}

export function createPartsAgreement(
  http: HttpClient,
  rootUrl: string,
  params: CreatePartsAgreement$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<PartsAgreementRestResponse>> {
  const rb = new RequestBuilder(rootUrl, createPartsAgreement.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PartsAgreementRestResponse>;
    }),
  );
}

createPartsAgreement.PATH = '/parts-agreement';
